// FILE: src/utils/timeFormat.js
// Display helpers for server-reported seconds. They format; they never count.

/** 5400 → "1 h 30 min"; 90 → "1 min"; 20 → "20 s"; 0 → "0 min". */
export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  if (s === 0) return "0 min";
  if (s < 60) return `${s} s`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (!h) return `${m} min`;
  return m ? `${h} h ${m} min` : `${h} h`;
}

/** mm:ss for a countdown. */
export function formatCountdown(ms) {
  const total = Math.max(0, Math.ceil((Number(ms) || 0) / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

/** Local clock time of an ISO date, e.g. "3:45 p.m.". */
export function formatClock(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-CA", { hour: "numeric", minute: "2-digit" });
}
